import { render } from "./NuevosExamenes.vue?vue&type=template&id=55ab89ae&scoped=true"
import script from "./NuevosExamenes.vue?vue&type=script&lang=js"
export * from "./NuevosExamenes.vue?vue&type=script&lang=js"

import "./NuevosExamenes.vue?vue&type=style&index=0&id=55ab89ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ab89ae"]])

export default __exports__